import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import superAdminLoginService from "./superAdminLoginService";
import { User } from "../../../pages/login/login.model";
import { StorageService } from "../../../core/storageService/storageService";
import { RootState } from "../../../app/store";


interface SuperAdminLogoutStateTypes {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
}

const initialState: SuperAdminLogoutStateTypes = {
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
};

//Login User


export const superAdminLogout = createAsyncThunk("home/logout", async (_, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.superAdminAuth.superAdminUser && state.superAdminAuth.superAdminUser.result.refresh_token;
    const response = await superAdminLoginService.superAdminLogout(token);
    if (response.isSuccess) {
      localStorage.removeItem("super_admin_user");
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

//Logout User
// export const logout = createAsyncThunk("auth/logout", async () => {
//   await loginService.logout();
// });
const clearUserDataFromLocalStorage = () => {
  localStorage.removeItem("super_admin_user");
  localStorage.removeItem("super_admin_refresh_token");
  localStorage.removeItem("super_admin_access_token");
};

export const superAdminLogoutSlice = createSlice({
  name: "superAdminAuth",
  initialState,
  reducers: {
    superAdminResetLogout: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
      clearUserDataFromLocalStorage();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(superAdminLogout.pending, (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      })
      .addCase(superAdminLogout.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(superAdminLogout.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action?.payload
      });
  },
});

export const { superAdminResetLogout } = superAdminLogoutSlice.actions;
// export default superAdminLogoutSlice.reducer;
